// Action Types

export const Types = {
  GET_WALLET_RESUME_REQUESTED: 'wallet/GET_WALLET_RESUME_REQUESTED',
  GET_WALLET_RESUME_SUCCEEDED: 'wallet/GET_WALLET_RESUME_SUCCEEDED',
  GET_WALLET_RESUME_FAILED: 'wallet/GET_WALLET_RESUME_FAILED',

  GET_FULL_STATEMENT_REQUESTED: 'wallet/GET_FULL_STATEMENT_REQUESTED',
  GET_FULL_STATEMENT_SUCCEEDED: 'wallet/GET_FULL_STATEMENT_SUCCEEDED',
  GET_FULL_STATEMENT_FAILED: 'wallet/GET_FULL_STATEMENT_FAILED',

  GET_RUBRICS_REQUESTED: 'wallet/GET_RUBRICS_REQUESTED',
  GET_RUBRICS_SUCCEEDED: 'wallet/GET_RUBRICS_SUCCEEDED',
  GET_RUBRICS_FAILED: 'wallet/GET_RUBRICS_FAILED',

  GET_SUBRUBRICS_REQUESTED: 'wallet/GET_SUBRUBRICS_REQUESTED',
  GET_SUBRUBRICS_SUCCEEDED: 'wallet/GET_SUBRUBRICS_SUCCEEDED',
  GET_SUBRUBRICS_FAILED: 'wallet/GET_SUBRUBRICS_FAILED',

  ADD_EXPENSE_REQUESTED: 'wallet/ADD_EXPENSE_REQUESTED',
  ADD_EXPENSE_SUCCEEDED: 'wallet/ADD_EXPENSE_SUCCEEDED',
  ADD_EXPENSE_FAILED: 'wallet/ADD_EXPENSE_FAILED',
}

// Action Creators

export function getWalletResume() {
  return {
    type: Types.GET_WALLET_RESUME_REQUESTED,
  }
}

export function getFullStatement() {
  return {
    type: Types.GET_FULL_STATEMENT_REQUESTED,
  }
}

export function getRubrics() {
  return {
    type: Types.GET_RUBRICS_REQUESTED,
  }
}

export function getSubRubrics(data) {
  return {
    type: Types.GET_SUBRUBRICS_REQUESTED,
    payload: data,
  }
}

export function addExpense(data) {
  return {
    type: Types.ADD_EXPENSE_REQUESTED,
    payload: data,
  }
}

// Reducer

const INITIAL_STATE = {
  getWalletResumeIsLoading: false,
  getWalletResumeError: null,
  walletResume: null,

  getFullStatementIsLoading: false,
  getFullStatementError: null,
  fullStatement: null,

  getRubricsIsLoading: false,
  getRubricsError: null,
  rubrics: null,

  getSubRubricsIsLoading: false,
  getSubRubricsError: null,
  subRubrics: null,

  addExpenseIsLoading: false,
  addExpenseSuccess: null,
  addExpenseError: null,
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_WALLET_RESUME_REQUESTED:
      return {
        ...state,
        getWalletResumeIsLoading: true,
      }
    case Types.GET_WALLET_RESUME_SUCCEEDED:
      return {
        ...state,
        getWalletResumeIsLoading: false,
        getWalletResumeError: null,
        walletResume: action.payload,
      }
    case Types.GET_WALLET_RESUME_FAILED:
      return {
        ...state,
        getWalletResumeIsLoading: false,
        getWalletResumeError: action.payload,
        walletResume: null,
      }

    case Types.GET_FULL_STATEMENT_REQUESTED:
      return {
        ...state,
        getFullStatementIsLoading: true,
      }
    case Types.GET_FULL_STATEMENT_SUCCEEDED:
      return {
        ...state,
        getFullStatementIsLoading: false,
        getFullStatementError: null,
        fullStatement: action.payload,
      }
    case Types.GET_FULL_STATEMENT_FAILED:
      return {
        ...state,
        getFullStatementIsLoading: false,
        getFullStatementError: action.payload,
        fullStatement: null,
      }

    case Types.GET_RUBRICS_REQUESTED:
      return {
        ...state,
        getRubricsIsLoading: true,
      }
    case Types.GET_RUBRICS_SUCCEEDED:
      return {
        ...state,
        getRubricsIsLoading: false,
        getRubricsError: null,
        rubrics: action.payload,
      }
    case Types.GET_RUBRICS_FAILED:
      return {
        ...state,
        getRubricsIsLoading: false,
        getRubricsError: action.payload,
        rubrics: null,
      }

    case Types.GET_SUBRUBRICS_REQUESTED:
      return {
        ...state,
        getSubRubricsIsLoading: true,
      }
    case Types.GET_SUBRUBRICS_SUCCEEDED:
      return {
        ...state,
        getSubRubricsIsLoading: false,
        getSubRubricsError: null,
        subRubrics: action.payload,
      }
    case Types.GET_SUBRUBRICS_FAILED:
      return {
        ...state,
        getSubRubricsIsLoading: false,
        getSubRubricsError: action.payload,
        subRubrics: null,
      }

    case Types.ADD_EXPENSE_REQUESTED:
      return {
        ...state,
        addExpenseIsLoading: true,
      }
    case Types.ADD_EXPENSE_SUCCEEDED:
      return {
        ...state,
        addExpenseIsLoading: false,
        addExpenseSuccess: true,
        addExpenseError: null,
      }
    case Types.ADD_EXPENSE_FAILED:
      return {
        ...state,
        addExpenseIsLoading: false,
        addExpenseSuccess: false,
        addExpenseError: action.payload,
      }

    default:
      return state
  }
}
